<template>
  <div class="container">
    <div class="page-header" v-if="(!windowTool && title) || desc">
      <div class="title" v-if="title">{{ title }}</div>
      <div class="desc" v-if="desc">{{ desc }}</div>
    </div>
    <div class="page-container">
      <div class="loading-box" v-if="loading">
        <a-spin />
      </div>
      <slot v-else />
    </div>
  </div>
</template>
<script lang="ts">
import {defineComponent, inject} from 'vue';
import {WindowTool} from '@/components/common/window/WindowInterface';

export default defineComponent({
  name: 'ScPage',
  props: {
    title: String,
    desc: String,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      windowTool: inject(WindowTool, null),
    };
  },
});
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex-grow: 1;
  .page-header {
    .title {
      color: $color-content-text-primary;
      font-size: $font-size-large;
      font-weight: $font-weight-primary;
      margin: $spacing-extra-large 0;
    }

    .desc {
      margin-bottom: $spacing-extra-large;
      color: $color-content-text-secondary;
      font-size: $font-size-small;
    }
  }
  .page-container {
    background: #fff;
    display: flex;
    flex-direction: column;
    overflow: auto;
    flex-grow: 1;

    .loading-box {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      justify-content: center;
      align-items: center;
    }
  }

}
</style>
